import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./ProjectGallery.css";

// ✅ Web Projects (with popup + slides)
const webProjects = [
  {
    id: 1,
    thumbnail: process.env.PUBLIC_URL + "/images/project1.jpg.png",
    slides: [
      process.env.PUBLIC_URL + "/images/project1.jpg.png",
      process.env.PUBLIC_URL + "/images/slide5.jpg.png",
      process.env.PUBLIC_URL + "/images/slide1.jpg.png",
      process.env.PUBLIC_URL + "/images/slide2.jpg.png",
      process.env.PUBLIC_URL + "/images/slide4.jpg.png",
      
    ],
    title: "Career Websites",
    sections: [
      {
        heading: "Hero Section",
        content: "Your future starts here explore endless career opportunities and take the next step toward your dream job.",
      },
      {
        heading: "About Section",
        content: "About Us section include professionals with companies that value creativity, innovation, and growth.",
      },
      {
        heading: "Career / Job Opportunities Section",
        content: "Discover the latest job openings, internships, and freelance positions tailored to your skills and interests.",
      },
       {
        heading: "Projects / Portfolio Section",
        content: "See real success stories, creative portfolios, and inspiring projects from talented individuals across industries.",
      },
        {
        heading: "Projects Section",
        content: "This part includes our employees'project",
      },
    ],
  },
  {
    id: 2,
    thumbnail: process.env.PUBLIC_URL + "/images/project2.jpg.png",
    slides: [
      process.env.PUBLIC_URL + "/images/project2.jpg.png",
      process.env.PUBLIC_URL + "/images/slide6.jpg.png",
      process.env.PUBLIC_URL + "/images/slide7.jpg.png",
      process.env.PUBLIC_URL + "/images/slide8.jpg.png",
    ],
    title: "Movie Themed Website",
    sections: [
      {
        heading: "Hero Section",
        content: "Experience the magic of cinema your favorite stories, all in one place.",
      },
      {
        heading: "Feature Section",
        content: "Discover trending movies, top picks, and fan-favorite collections.",
      },
      {
        heading: "Upcoming Movies",
        content: "Stay ahead with the latest releases and upcoming blockbusters.",
      },
        {
        heading: "Video Section",
        content: "Watch trailers, behind-the-scenes moments, and exclusive clips.",
      },
    ],
  },
  {
    id: 3,
    thumbnail: process.env.PUBLIC_URL + "/images/project3.jpg.png",
    slides: [
      process.env.PUBLIC_URL + "/images/project3.jpg.png",
      process.env.PUBLIC_URL + "/images/slide40.jpg.png",
      process.env.PUBLIC_URL + "/images/slide9.jpg.png",
      process.env.PUBLIC_URL + "/images/slide10.jpg.png",
    ],
    title: "Beauty wbsite",
    sections: [
      {
        heading: "Hero Section",
        content: "This is the first thing visitors see. It includes a dynamic slider showcasing my featured projects and highlights, giving a quick overview of my skills and style.",
      },
      {
        heading: "About Us Section",
        content: "This section introduces who I am, my background, and my journey as a designer and developer.",
      },
      {
        heading: "Stand Out With Style Section",
        content: "Here I showcase my approach to design and creativity. This section emphasizes how my work captures attention through unique visuals and thoughtful design choices.",
      },
         {
        heading: "Services Section",
        content: "This section details the professional services I provide, such as web design, UI/UX design, and interactive development, helping potential clients know how I can support their projects.",
      },
    ],
  },

   {
    id: 4,
    thumbnail: process.env.PUBLIC_URL + "/images/slide26.jpg.png",
    slides: [
      process.env.PUBLIC_URL + "/images/slide26.jpg.png",
      process.env.PUBLIC_URL + "/images/slide50.jpg.png",
      process.env.PUBLIC_URL + "/images/slide24.jpg.png",
      
      
    ],
    title: "Park Website",
    sections: [
      {
        heading: "Hero Section",
        content: "Content: Welcomes visitors with stunning park visuals and a call-to-action to explore.",
      },
      {
        heading: "Gallery Section",
        content: "Displays images of the park’s landscapes, activities, and highlights.",
      },
      {
        heading: "Footer Section",
        content: "Provides contact info, social links, and quick navigation for visitors.",
      },
    ],
  },

   {
    id: 1,
    thumbnail: process.env.PUBLIC_URL + "/images/project5.jpg.png",
    slides: [
      process.env.PUBLIC_URL + "/images/project5.jpg.png",
      process.env.PUBLIC_URL + "/images/slide15.jpg.png",
      process.env.PUBLIC_URL + "/images/slide16.jpg.png",
      process.env.PUBLIC_URL + "/images/slide18.jpg.png",
      process.env.PUBLIC_URL + "/images/slide17.jpg.png",
    ],
 title: "Technology Website",
    sections: [
      {
        heading: "Hero Section",
        content: "Welcomes visitors with a bold introduction and highlights of the company’s tech innovations.",
      },
      {
        heading: "About Us Section",
        content: "Introduces the company, its mission, and expertise in the technology industry.",
      },
        {
        heading: "Smart Future Technologies Section",
        content: "Showcases cutting-edge technologies and innovative solutions developed by the company.",
      },
        {
        heading: "Our Service Section",
        content: "Summarizes the key services offered, helping clients understand what the company can provide.",
      },
      {
        heading: "Footer Section",
        content: "Includes contact form.",
      },
    ],
  },

   {
    id: 1,
    thumbnail: process.env.PUBLIC_URL + "/images/project6.jpg.png",
    
    slides: [
      process.env.PUBLIC_URL + "/images/project6.jpg.png",
      process.env.PUBLIC_URL + "/images/slide11.jpg.png",
      process.env.PUBLIC_URL + "/images/slide12.jpg.png",
      process.env.PUBLIC_URL + "/images/slide13.jpg.png",
      process.env.PUBLIC_URL + "/images/slide14.jpg.png",
    ],
    title: "Travel Website",
    sections: [
      {
        heading: "Hero Section",
        content: "Welcomes visitors with stunning travel visuals and inspires exploration.",
      },
      {
        heading: "Find Your Destination Section",
        content: "Helps users search and discover their ideal travel destinations.",
      },
        {
        heading: "Popular Destinations Section",
        content: "Highlights top travel spots to inspire users’ next trips.",
      },
        {
        heading: "Latest Travel Trips Section",
        content: "Shows recent travel experiences and updates for visitors to explore.",
      },
      {
        heading: "Signup Form Section",
        content: "Allows users to subscribe for updates, deals, and travel inspiration.",
      },
    ],
  },

   {
    id: 1,
    thumbnail: process.env.PUBLIC_URL + "/images/project7.jpg.png",
      slides: [
      process.env.PUBLIC_URL + "/images/project7.jpg.png",
      process.env.PUBLIC_URL + "/images/slide30.jpg.png",
      process.env.PUBLIC_URL + "/images/slide20.jpg.png",
    ],
 
    title: "Calculator",
    sections: [
      {
        heading: "iphone Calculator",
        content: "Welcomes users with a sleek iPhone-style interface and highlights the calculator’s features.",
      },
      {
        heading: "Advance Calculator",
        content: "Main functional area for performing complex calculations, including scientific functions and formulas.",
      },
      {
        heading: "Advance Calculator",
        content: "Main functional area for performing complex calculations, including scientific functions and formulas.",
      },
    ],
  },

   {
    id: 1,
    thumbnail: process.env.PUBLIC_URL + "/images/project10.jpg.png",
    slides: [
      process.env.PUBLIC_URL + "/images/project10.jpg.png",
      process.env.PUBLIC_URL + "/images/slide27.jpg.png",
      process.env.PUBLIC_URL + "/images/slide28.jpg.png",
      process.env.PUBLIC_URL + "/images/slide29.jpg.png",
    ],
    title: "3D Artwork website",
    sections: [
      {
        heading: "Hero Section",
        content: "Welcomes visitors with stunning 3D visuals and highlights key artwork pieces.",
      },
      {
        heading: "Features",
        content: "Showcases 3D models, renders, and artwork in an interactive gallery format.",
      },
      {
        heading: "What People Say Section",
        content: "Showcases feedback and testimonials from clients, users, or collaborators to build trust and credibility.",
      },
        {
        heading: "Live Action Section",
        content: "Highlights real-time demonstrations, videos, or interactive experiences to showcase projects or artwork in action.",
      },
    ],
  },

   {
    id: 1,
    thumbnail: process.env.PUBLIC_URL + "/images/project8.jpg.png",
    slides: [
      process.env.PUBLIC_URL + "/images/project8.jpg.png",
      process.env.PUBLIC_URL + "/images/slide34.jpg.png",
      process.env.PUBLIC_URL + "/images/slide35.jpg.png",
    ],
    title: "My Awesome shop",
    sections: [
      {
        heading: "My Awesome shop",
        content: "Showcases available items with images, descriptions, and prices for easy browsing",
      },
      {
        heading: "My Awesome shop",
        content: "Showcases items in cards with prices for easy browsing",
      },
    ],
  },

   {
    id: 1,
    thumbnail: process.env.PUBLIC_URL + "/images/project9.jpg.png",
    slides: [
      process.env.PUBLIC_URL + "/images/project9.jpg.png",
      process.env.PUBLIC_URL + "/images/slide19.jpg.png",
      process.env.PUBLIC_URL + "/images/slide21.jpg.png",
      process.env.PUBLIC_URL + "/images/slide22.jpg.png",
      process.env.PUBLIC_URL + "/images/slide23.jpg.png",
    ],
    title: "Portfolio Website",
    sections: [
      {
        heading: "Hero Section",
        content: "Welcomes visitors with a brief introduction and highlights of your work and skills.",
      },
      {
        heading: "Certificates Section",
        content: "Showcases professional certificates and achievements.",
      },
      {
        heading: "Skills Section",
        content: "Displays key technical and creative skills.",
      },
       {
        heading: "Experience Section",
        content: "Summarizes work history and projects.",
      },
       {
        heading: "Contact Section",
        content: "Provides ways for visitors or potential clients to get in touch.",
      },
    ],
  },

   {
    id: 1,
    thumbnail: process.env.PUBLIC_URL + "/images/slide80.jpg.png",
    slides: [
      process.env.PUBLIC_URL + "/images/slide80.jpg.png",
      process.env.PUBLIC_URL + "/images/slide90.jpg.png",
    ],
    title: "AI Projects",
    sections: [
      {
        heading: "Joke Generator",
        content: "Welcomes users with a modern interface and highlights AI-generated content features.",
      },
      {
        heading: "World Clock",
        content: "Introduces the world clock with a clean, intuitive interface.",
      },
    ],
  },

   {
    id: 1,
    thumbnail: process.env.PUBLIC_URL + "/images/slide31.jpg.png",
    slides: [
      process.env.PUBLIC_URL + "/images/slide31.jpg.png",
      process.env.PUBLIC_URL + "/images/slide32.jpg.png",
      process.env.PUBLIC_URL + "/images/slide33.jpg.png",
    ],
    title: "Portfolio Website",
    sections: [
      {
        heading: "Hero Section",
        content: "Welcomes visitors with a brief introduction and highlights of your work and skills.",
      },
      {
        heading: "About Me Section",
        content: "Introduces who you are, your background, passions, and professional journey in a concise way to connect with visitors.",
      },
      {
        heading: "Skills Section",
        content: "Displays key technical and creative skills.",
      },
    ],
  },
];



// 🎨 Graphic Design Projects (with simple popup — single image)
const graphicProjects = Array.from({ length: 8 }, (_, i) => ({
  id: i + 1,
  image: process.env.PUBLIC_URL + `/images/graphic${i + 1}.jpg.jpg`,
  title: `Graphic Design ${i + 1}`,
  description: `A creative graphic design project showcasing layout, typography, and visual storytelling.`,
}));

const ProjectGallery = () => {
  const [selected, setSelected] = useState(null);
  const [slideIndex, setSlideIndex] = useState(0);
  const [graphicSelected, setGraphicSelected] = useState(null);

  const nextSlide = () => {
    if (selected && slideIndex < selected.slides.length - 1)
      setSlideIndex(slideIndex + 1);
  };

  const prevSlide = () => {
    if (selected && slideIndex > 0) setSlideIndex(slideIndex - 1);
  };

  return (
    <section className="gallery-section dark-theme">
      {/* 🌐 Web Projects */}
      <h2 className="section-title">
        Web <span>Projects</span>
      </h2>

      <div className="gallery-grid">
        {webProjects.map((proj) => (
          <div key={proj.id} className="gallery-card">
            <img src={proj.thumbnail} alt={proj.title} />
            <div className="card-overlay">
              <h3>{proj.title}</h3>
              <button
                className="view-btn"
                onClick={() => {
                  setSelected(proj);
                  setSlideIndex(0);
                }}
              >
                View More →
              </button>
            </div>
          </div>
        ))}
      </div>

    <br></br>
      <div className="gallery-grid graphic-grid">
        {graphicProjects.map((proj) => (
          <div key={proj.id} className="gallery-card">
            <img src={proj.image} alt={proj.title} />
            <div className="card-overlay">
              <h3>{proj.title}</h3>
              <button
                className="view-btn"
                onClick={() => setGraphicSelected(proj)}
              >
                View Details →
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* ✅ Popup for Web Projects (with slides) */}
      {selected && (
        <div className="popup" onClick={() => setSelected(null)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelected(null)}>
              ×
            </button>

            <img
              src={selected.slides[slideIndex]}
              alt={`${selected.title} Slide ${slideIndex + 1}`}
              className="popup-image"
            />

            <div className="popup-body">
              <h3>
                {
                  selected.sections[slideIndex % selected.sections.length]
                    .heading
                }
              </h3>
              <p>
                {
                  selected.sections[slideIndex % selected.sections.length]
                    .content
                }
              </p>

              <div className="nav-arrows">
                <button onClick={prevSlide} disabled={slideIndex === 0}>
                  ←
                </button>
                <button
                  onClick={nextSlide}
                  disabled={slideIndex === selected.slides.length - 1}
                >
                  →
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Simple Popup for Graphic Projects */}
      {graphicSelected && (
        <div className="popup" onClick={() => setGraphicSelected(null)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="close-btn"
              onClick={() => setGraphicSelected(null)}
            >
              ×
            </button>

            <img
              src={graphicSelected.image}
              alt={graphicSelected.title}
              className="popup-image"
            />
            <div className="popup-body">
              <h3>{graphicSelected.title}</h3>
              <p>{graphicSelected.description}</p>
            </div>
          </div>
        </div>
      )}

      <div className="back-btn-container">
        <Link to="/projects" className="back-btn">
          ← Back to Projects
        </Link>
      </div>
    </section>
  );
};

export default ProjectGallery;
